export const EnvironmentTypes = {
    production: 'production',
    development: 'development',
};
export const Env = process.env.NODE_ENV === 'production'
    ? EnvironmentTypes.production
    : EnvironmentTypes.development;
export const isProd = Env === EnvironmentTypes.production;
export const isDev = Env === EnvironmentTypes.development;
export const isBrowser = typeof window !== 'undefined';
export const isTst1 = process.env.PT_USE_TST1 === 'true' || process.env.NEXT_PUBLIC_TST1 === 'true';
